
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import { GetStaticPaths, GetStaticProps } from 'next';
import { SearchedProfileManager } from 'modules/App/server';
import HeaderLayout from 'modules/common/layouts/HeaderLayout';
import Hero from 'modules/common/components/Hero';
import { useAuthModal } from 'modules/auth';
import dbConnect from 'utils/db';
import { SearchedProfile } from 'modules/App/interfaces';
import MissionsList from 'modules/App/components/MissionsList';
import { Section } from '@/lib/components/layout/section';
import MissionsCities from 'modules/App/components/MissionsCities';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from '@/lib/components/ui/breadcrumb';
import EmptyState from 'modules/common/components/EmptyState';
import omit from 'lodash/fp/omit';
export interface MissionsProps {
    searchedProfiles: SearchedProfile[];
    city: string;
    cities: string[];
}
function Missions({ searchedProfiles, city, cities }: MissionsProps) {
    const { toggleModal } = useAuthModal();
    return (<HeaderLayout title={`${searchedProfiles.length} offres d’emploi à pourvoir immédiatement à ${city}`} description="Tu as une mission parfaite pour un de ces candidats ? Propose-lui une mission et gagne la prime.">
      <Hero title={<>
            <span className="text-primary">{searchedProfiles.length}</span> offres d’emploi
            <br />
            dispos à <span className="text-primary">{city}</span>
          </>} description={<>
            Tu as mission parfaite pour un de ces candidats&nbsp;?
            <br />
            <strong className="link link-primary" onClick={() => toggleModal()}>
              Inscris-toi
            </strong>
            , <strong>propose ta mission</strong> et <strong>satisfais ton client</strong> plus rapidement.
          </>}/>
      <Section variant="full" className="container mx-auto">
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink href="/cvtheque">Toutes les villes</BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>
                Missions à <strong>{city}</strong>
              </BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </Section>
      {searchedProfiles.length === 0 ? (<EmptyState title={`Aucune mission disponible en ce moment à ${city}`} className="my-16"/>) : (<MissionsList missions={searchedProfiles}/>)}
      <Section className="bg-gray-50">
        <MissionsCities cities={cities}/>
      </Section>
    </HeaderLayout>);
}
export const getStaticPaths: GetStaticPaths = async () => {
    await dbConnect();
    const { cities } = await SearchedProfileManager.listNotConnected();
    const paths = cities?.map((area) => ({
        params: { slug: area.slug },
    })) || [];
    return {
        paths,
        fallback: 'blocking',
    };
};
const getStaticProps: GetStaticProps<MissionsProps> = async ({ params }) => {
    await dbConnect();
    const { cities: allCities } = await SearchedProfileManager.listNotConnected();
    const city = allCities.find((cityObject) => cityObject.slug === (params?.slug as string));
    const { items: searchedProfiles, cities } = await SearchedProfileManager.listNotConnected({
        filter: { area: omit(['slug'])(city) },
    });
    return {
        props: {
            city: params?.slug as string,
            searchedProfiles: JSON.parse(JSON.stringify(searchedProfiles)),
            cities: JSON.parse(JSON.stringify(cities.filter((city) => city.slug !== params?.slug).map((city) => city.name))),
        },
        revalidate: 60,
    };
};
export default Missions;

    async function __Next_Translate__getStaticProps__1989496f592__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/missions/ville/[slug]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1989496f592__ as getStaticProps }
  